export const sessionFormRulesConfig = {
    signature_max_length: 100,
    meeting_place_max_length: 800,
    name_max_length: 400,
}
